import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';

import setGlobalJQuery from '../../../../modules/jquery';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import HeadingSection from '../../../siteBaseSections/HeadingSection/HeadingSection';
import Utils from '../../../../utils';
import { renderCSSString } from '../../../../helpers';
import CallToAction from '../../../shared/CallToAction/CallToAction';

import './GrowTixView.scss';

export class GrowTixView extends Component {
  componentDidMount() {
    const {
      siteHeader: { data: { growTixEventId = '' } = {} },
      siteContent: { data: { path = '', id: personId = '' } = {} } = {},
      match: { params: { guestPath = '' } = {} } = {},
    } = this.props;

    if (growTixEventId) {
      window.gt_event_id = growTixEventId;

      // we don't download schedule_index.js and people_view.js from growtix.com, because we extended them by our code
      if (path === 'schedule') {
        setGlobalJQuery().then(() => {
          // initial script you can find here: https://register.growtix.com/js/embed/schedule_index.js
          Utils.addScriptTag('/js/growTixScheduleScript.js');
        });
      } else if (guestPath && personId && path) {
        if (!Array.isArray(window.growTixGuests)) {
          window.growTixGuests = [];
        }

        window.growTixGuests.push({
          gt_person_id: personId,
        });
        setGlobalJQuery().then(() => {
          // initial script you can find here: https://register.growtix.com/js/embed/people_view.js
          Utils.addScriptTag('/js/growTixGuestsScript.js');
        });
      }
    }
  }

  render() {
    const {
      siteHeader: { meta: { title: defaultTitle } = {} } = {},
      siteContent: {
        data: {
          details: { description = '', title = '' } = {},
          description: personDescription = '',
          path = '',
          primaryLink: primaryCTAConfig,
          secondaryLink: secondaryCTAConfig,
          id: personId = '',
          name: pageName = '',
        } = {},
        meta: { title: contentTitle } = {},
      } = {},
      t,
      options: {
        data: { brand: { colours: { accent = '' } = {} } = {} } = {},
      } = {},
    } = this.props;
    const pageDescription = description || personDescription;
    const isSchedulePage = path === 'schedule';
    const isPageHeading = pageDescription || title;
    const growTixTypeClass = classnames('v-grow-tix-view', {
      'v-grow-tix-view__schedule': isSchedulePage,
      'v-grow-tix-view__schedule--with-heading':
        isSchedulePage && isPageHeading,
      'v-grow-tix-view__guest-bio': !isSchedulePage,
    });
    const pageNameTitle = isSchedulePage
      ? t('event.schedule')
      : t('event.guest');

    const growTixPageStyles = renderCSSString(`
      .v-grow-tix-view__guest-bio .row .img-responsive {
        border-bottom: 6px solid #${accent};
      }
      
      .v-grow-tix-view__guest-bio .row i.fa {
        color: #${accent};
      }
      
      .v-grow-tix-view .nav-tabs .active {
        border-bottom: 4px solid #${accent};
      }
      
      .v-grow-tix-view .nav-tabs li:hover {
        border-bottom: 4px solid #${accent};
      }
    `);

    const contentId = personId ? `gt_content_${personId}` : 'gt_content';

    return (
      <SiteLayout
        helmet={{
          title:
            contentTitle || `${pageName || pageNameTitle} | ${defaultTitle}`,
        }}
        style={{ backgroundColor: 'white' }}
      >
        {primaryCTAConfig?.shown && (
          <div className="container v-grow-tix-view__guest-bio-cta--before-content">
            <CallToAction
              ctaConfig={primaryCTAConfig}
              mode="black"
              look="hollow"
              testId="agenda-primary-cta"
            />
          </div>
        )}

        {isPageHeading && (
          <HeadingSection
            title={title}
            text={pageDescription}
            columnWrap={7}
            isBrand={false}
          />
        )}

        <section className={growTixTypeClass}>
          {growTixPageStyles}
          <div className="container">
            <div id={contentId} />
          </div>
        </section>

        {secondaryCTAConfig?.shown && (
          <div className="container v-grow-tix-view__guest-bio-cta--after-content">
            <CallToAction
              ctaConfig={secondaryCTAConfig}
              mode="black"
              look="hollow"
              testId="agenda-secondary-cta"
            />
          </div>
        )}
      </SiteLayout>
    );
  }
}

GrowTixView.propTypes = {
  siteHeader: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  siteContent: PropTypes.shape({
    data: PropTypes.shape({
      sections: PropTypes.array,
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  options: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteContent: state.siteContent,
    options: state.options,
  };
}

export default withTranslation()(connect(mapStateToProps)(GrowTixView));
